import { render } from "./AssetTypeEditHeader.vue?vue&type=template&id=ad25591e"
import script from "./AssetTypeEditHeader.vue?vue&type=script&lang=js"
export * from "./AssetTypeEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__